// Lets any component (header button, dashboard tile) reopen the announcement
// dialog without threading state through the layout.
export const OPEN_ANNOUNCEMENT_EVENT = "announcement:open";

export const openAnnouncement = () => {
  window.dispatchEvent(new Event(OPEN_ANNOUNCEMENT_EVENT));
};
